webpackJsonp([242291099715838],{

/***/ 58:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.ApiComingSoonComponent = undefined;
	
	var _dec, _class, _class2, _temp;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactI18next = __webpack_require__(5);
	
	__webpack_require__(70);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ApiComingSoonComponent = exports.ApiComingSoonComponent = (_dec = (0, _reactI18next.translate)("business-apis"), _dec(_class = (_temp = _class2 = function (_Component) {
	    _inherits(ApiComingSoonComponent, _Component);
	
	    function ApiComingSoonComponent(props) {
	        _classCallCheck(this, ApiComingSoonComponent);
	
	        return _possibleConstructorReturn(this, _Component.call(this, props));
	    }
	
	    ApiComingSoonComponent.prototype.render = function render() {
	        var t = this.props.t;
	
	        return _react2.default.createElement(
	            "div",
	            { className: "km-api-coming-soon-component" },
	            _react2.default.createElement(
	                "div",
	                { className: "container-fluid" },
	                _react2.default.createElement(
	                    "div",
	                    { className: "row justify-content-center" },
	                    _react2.default.createElement(
	                        "div",
	                        { className: "col-9 col-lg-8 col-xl-6" },
	                        _react2.default.createElement(
	                            "h2",
	                            null,
	                            t("apis.coming-soon")
	                        )
	                    )
	                )
	            )
	        );
	    };
	
	    return ApiComingSoonComponent;
	}(_react.Component), _class2.propTypes = {
	    t: _propTypes2.default.func
	}, _temp)) || _class);

/***/ }),

/***/ 70:
/***/ (function(module, exports) {

	// empty (null-loader)

/***/ }),

/***/ 59:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _apiHeader = __webpack_require__(19);
	
	Object.defineProperty(exports, "ApiHeaderComponent", {
	  enumerable: true,
	  get: function get() {
	    return _apiHeader.ApiHeaderComponent;
	  }
	});
	
	var _apiHowItWorks = __webpack_require__(20);
	
	Object.defineProperty(exports, "ApiHowItWorksComponent", {
	  enumerable: true,
	  get: function get() {
	    return _apiHowItWorks.ApiHowItWorksComponent;
	  }
	});
	
	var _apiDocs = __webpack_require__(21);
	
	Object.defineProperty(exports, "ApiDocsComponent", {
	  enumerable: true,
	  get: function get() {
	    return _apiDocs.ApiDocsComponent;
	  }
	});
	
	var _apiPricing = __webpack_require__(22);
	
	Object.defineProperty(exports, "ApiPricingComponent", {
	  enumerable: true,
	  get: function get() {
	    return _apiPricing.ApiPricingComponent;
	  }
	});
	
	var _useCases = __webpack_require__(26);
	
	Object.defineProperty(exports, "ApiUseCasesComponent", {
	  enumerable: true,
	  get: function get() {
	    return _useCases.ApiUseCasesComponent;
	  }
	});
	
	var _payment = __webpack_require__(87);
	
	Object.defineProperty(exports, "PaymentComponent", {
	  enumerable: true,
	  get: function get() {
	    return _payment.PaymentComponent;
	  }
	});
	
	var _apiComingSoon = __webpack_require__(58);
	
	Object.defineProperty(exports, "ApiComingSoonComponent", {
	  enumerable: true,
	  get: function get() {
	    return _apiComingSoon.ApiComingSoonComponent;
	  }
	});
	
	var _relatedApis = __webpack_require__(25);
	
	Object.defineProperty(exports, "ApiRelatedApisComponent", {
	  enumerable: true,
	  get: function get() {
	    return _relatedApis.ApiRelatedApisComponent;
	  }
	});

/***/ }),

/***/ 327:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.default = undefined;
	
	var _dec, _class, _class2, _temp;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactI18next = __webpack_require__(5);
	
	__webpack_require__(603);
	
	var _reactHelmet = __webpack_require__(7);
	
	var _apiHeader = __webpack_require__(19);
	
	var _apiHowItWorks = __webpack_require__(20);
	
	var _footer = __webpack_require__(8);
	
	var _export = __webpack_require__(59);
	
	var _googleAnalytics = __webpack_require__(10);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var KycApiPage = (_dec = (0, _reactI18next.translate)("business-apis"), _dec(_class = (_temp = _class2 = function (_Component) {
	    _inherits(KycApiPage, _Component);
	
	    function KycApiPage(props) {
	        _classCallCheck(this, KycApiPage);
	
	        return _possibleConstructorReturn(this, _Component.call(this, props));
	    }
	
	    KycApiPage.prototype.componentDidMount = function componentDidMount() {
	        _googleAnalytics.GoogleAnalyticsService.registerPageView();
	    };
	
	    KycApiPage.prototype.render = function render() {
	        var t = this.props.t;
	
	
	        return _react2.default.createElement(
	            "div",
	            { className: "km-kyc-api-page" },
	            _react2.default.createElement(_reactHelmet.Helmet, { title: t("apis.kyc.page.title") + " - Kumuluz" }),
	            _react2.default.createElement(_apiHeader.ApiHeaderComponent, { title: t("apis.kyc.page.title"),
	                paragraphs: [t("apis.kyc.page.para")],
	                paragraphsOrientation: "row"
	            }),
	            _react2.default.createElement(
	                _apiHowItWorks.ApiHowItWorksComponent,
	                { title: t("apis.kyc.page.how-it-works.title") },
	                _react2.default.createElement(
	                    "p",
	                    null,
	                    t("apis.kyc.page.how-it-works.para")
	                )
	            ),
	            _react2.default.createElement(_export.ApiComingSoonComponent, null),
	            _react2.default.createElement(_footer.Footer, { social: true })
	        );
	    };
	
	    return KycApiPage;
	}(_react.Component), _class2.propTypes = {
	    t: _propTypes2.default.func
	}, _temp)) || _class);
	exports.default = KycApiPage;
	module.exports = exports["default"];

/***/ }),

/***/ 603:
/***/ (function(module, exports) {

	// empty (null-loader)

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-business-apis-kyc-index-js-65b5982dd069acdae115.js